import React, { useState } from "react";

type IProps = React.ImgHTMLAttributes<HTMLImageElement>;

const fix = (e: React.SyntheticEvent<HTMLImageElement, Event>) =>
  ((e.target as HTMLImageElement).style.display = "none");
const Img = ({ alt = "", src, ...props }: IProps) => (
  <img {...props} src={src} alt={alt} onError={fix} />
);
export default Img;

const av = ({ alt = "" }) => {
  if (!alt) return null;
  const m = /([\w]).*\s([\w])/.exec(alt);
  alt = m ? m[1] + m[2] : alt.substr(0, 2);
  return (
    <div
      style={{
        background: "purple",
        color: "white",
        height: "100%",
        textAlign: "center",
        fontSize: "24px",
        borderRadius: "50%",
      }}
    >
      {alt}
    </div>
  );
};

export const ImgA = ({
  alt = "",
  alternative = av,
  src,
  ...props
}: IProps & { alternative?: (p: IProps) => React.ReactElement | null }) => {
  const [error, setError] = useState(false);
  if (error) return alternative({ ...props, alt });
  return <img {...props} src={src} alt={alt} onError={() => setError(true)} />;
};
